
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M11.0001 3.22998C11.0001 2.58998 10.4101 2.09998 9.7901 2.23998C8.6701 2.49998 7.6101 2.93998 6.6701 3.53998C6.1401 3.87998 6.0601 4.63998 6.5101 5.08998C6.8301 5.40998 7.3401 5.48998 7.7201 5.24998C8.4901 4.75998 9.3401 4.39998 10.2601 4.19998C10.7001 4.09998 11.0001 3.68998 11.0001 3.22998ZM17.3301 3.54998C16.3901 2.94998 15.3301 2.50998 14.2101 2.24998C13.5901 2.10998 13.0001 2.58998 13.0001 3.22998C13.0001 3.67998 13.3001 4.09998 13.7401 4.18998C14.6501 4.38998 15.5101 4.75998 16.2701 5.23998C16.6601 5.47998 17.1601 5.40998 17.4801 5.07998C17.9401 4.63998 17.8701 3.88998 17.3301 3.54998ZM20.7701 11C21.4101 11 21.9001 10.41 21.7601 9.78998C21.5001 8.66998 21.0601 7.60998 20.4601 6.66998C20.1201 6.13998 19.3601 6.05998 18.9101 6.50998C18.5901 6.82998 18.5101 7.33998 18.7501 7.71998C19.2401 8.48998 19.6001 9.33998 19.8001 10.25C19.9001 10.7 20.3101 11 20.7701 11ZM5.1001 6.50998C4.6401 6.05998 3.8901 6.12998 3.5501 6.66998C2.9501 7.60998 2.5101 8.66998 2.2501 9.78998C2.1101 10.41 2.5901 11 3.2301 11C3.6801 11 4.1001 10.7 4.1901 10.26C4.3901 9.34998 4.7601 8.48998 5.2401 7.72998C5.5001 7.33998 5.4201 6.82998 5.1001 6.50998ZM3.2301 13C2.5901 13 2.1001 13.59 2.2401 14.21C2.5001 15.33 2.9401 16.38 3.5401 17.33C3.8801 17.87 4.6401 17.94 5.0901 17.49C5.4101 17.17 5.4901 16.66 5.2401 16.28C4.7501 15.52 4.3901 14.67 4.1901 13.75C4.1001 13.3 3.6901 13 3.2301 13ZM15.0001 12C15.0001 10.34 13.6601 8.99998 12.0001 8.99998C10.3401 8.99998 9.0001 10.34 9.0001 12C9.0001 13.66 10.3401 15 12.0001 15C13.6601 15 15.0001 13.66 15.0001 12ZM18.9001 17.49C19.3501 17.94 20.1101 17.87 20.4501 17.34C21.0501 16.4 21.4901 15.34 21.7501 14.23C21.8901 13.61 21.4001 13.02 20.7701 13.02C20.3201 13.02 19.9001 13.32 19.8101 13.76C19.6101 14.67 19.2401 15.52 18.7601 16.29C18.5001 16.66 18.5801 17.17 18.9001 17.49ZM13.0001 20.77C13.0001 21.41 13.5901 21.9 14.2101 21.76C15.3301 21.5 16.3801 21.06 17.3301 20.46C17.8701 20.12 17.9401 19.36 17.4901 18.91C17.1701 18.59 16.6601 18.51 16.2801 18.76C15.5201 19.25 14.6701 19.61 13.7501 19.81C13.3001 19.9 13.0001 20.31 13.0001 20.77ZM6.6701 20.45C7.6201 21.05 8.6701 21.49 9.7901 21.75C10.4101 21.89 11.0001 21.4 11.0001 20.77C11.0001 20.32 10.7001 19.9 10.2601 19.81C9.3501 19.61 8.4901 19.24 7.7301 18.76C7.3401 18.52 6.8401 18.59 6.5201 18.92C6.0601 19.36 6.1301 20.11 6.6701 20.45Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-filter-tilt-shift`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconFilterTiltShift

    ```js
    <b-new-b-icon-filter-tilt-shift />
    ```
</docs>


